import _ from "lodash";
import secureLocalStorage from "react-secure-storage";
import { API_URL } from "../config/environment";

const technofunctionalities = {
  substitution_de_matiere_grasse: "Substitut de matière grasse",
  selection_des_antimicrobiens: "Antimicrobien",
  substitution_des_sucres: "Substitut de sucre",
  selection_des_antioxydants: "Antioxidant",
  selection_des_emulsifiants: "Agent emulsifiant",
  selection_des_moussants: "Agent moussant",
  selection_des_epaississants: "Agent epaississant",
};

export function restructureOptions(options) {
  const restructuredOptions = options.map((option) => ({
    value: [option],
    label: option,
    // relatedColumns: [option],
  }));

  return restructuredOptions;
}

export function getPreviousSelections(
  questions,
  questionId,
  answers,
  selectedOptions
) {
  const previousSelections = [];

  // For all previous questions (before current question)
  questions.forEach((question) => {
    if (question.id < questionId && answers[question.id] === "Yes") {
      if (question.requiresDropdown) {
        const selectedValue = selectedOptions[question.id];
        if (selectedValue) {
          previousSelections.push({
            field: question.field,
            value: selectedValue,
          });
        }
      } else {
        previousSelections.push({
          field: question.field,
          value: true,
        });
      }
    }
  });

  return previousSelections;
}

export const _fetchFilteredIngredients = async (
  url,
  field,
  relatedColumns,
  technofunctionality
) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ field, relatedColumns, technofunctionality }),
    });

    if (!response.ok) {
      console.error("Error fetching filtered ingredients");
      return [];
    }

    const data = await response.json();
    if (!data || !data.ingredients) {
      console.error("Error fetching filtered ingredients: No data found");
      return [];
    }

    return data.ingredients;
  } catch (error) {
    console.error("Error fetching filtered ingredients");
    return [];
  }
};

export const _fetchOptions = async (
  url,
  questionId,
  field,
  questions,
  answers,
  selectedOptions,
  technofunctionality
) => {
  try {
    if (!field) {
      // setOptions((prevOptions) => ({ ...prevOptions, [questionId]: [] }));
      const optionsFn = (prevOptions) => ({ ...prevOptions, [questionId]: [] });
      return optionsFn;
    }

    const previousSelections = getPreviousSelections(
      questions,
      questionId,
      answers,
      selectedOptions
    );

    // const url = `${API_URL}/filter-options`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ field, technofunctionality }),
    });

    if (!response.ok) {
      console.error("Error fetching options:", response.statusText);
      const optionsFn = (prevOptions) => ({
        ...prevOptions,
        [questionId]: [],
      });
      return optionsFn;
    }

    const data = await response.json();
    if (!data || !data.options) {
      console.error("Error fetching options: No data found");
      const optionsFn = (prevOptions) => ({
        ...prevOptions,
        [questionId]: [],
      });
      return optionsFn;
    }

    const optionsFn = (prevOptions) => ({
      ...prevOptions,
      [questionId]: restructureOptions(data.options),
    });
    return optionsFn;
  } catch (error) {
    console.error("Error fetching options:", error);
    const optionsFn = (prevOptions) => ({ ...prevOptions, [questionId]: [] });
    return optionsFn;
  }
};

export const newFetchOptions = async (
  url,
  questionId,
  field,
  technofunctionality
) => {
  try {
    if (!field) {
      // setOptions((prevOptions) => ({ ...prevOptions, [questionId]: [] }));
      const optionsFn = (prevOptions) => ({ ...prevOptions, [questionId]: [] });
      return optionsFn;
    }

    // const url = `${API_URL}/filter-options`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ field, technofunctionality }),
    });

    if (!response.ok) {
      console.error("Error fetching options:", response.statusText);
      const optionsFn = (prevOptions) => ({
        ...prevOptions,
        [questionId]: [],
      });
      return optionsFn;
    }

    const data = await response.json();
    if (!data || !data.options) {
      console.error("Error fetching options: No data found");
      const optionsFn = (prevOptions) => ({
        ...prevOptions,
        [questionId]: [],
      });
      return optionsFn;
    }

    const optionsFn = (prevOptions) => ({
      ...prevOptions,
      [questionId]: restructureOptions(data.options),
    });
    return optionsFn;
  } catch (error) {
    console.error("Error fetching options:", error);
    const optionsFn = (prevOptions) => ({ ...prevOptions, [questionId]: [] });
    return optionsFn;
  }
};

export const filterDataByField = (data, field, values) => {
  try {
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error(
        "Invalid dataset provided. It should be an array of objects."
      );
    }

    // Normalize the input 'values' array to use a hyphen (-) consistently
    const valuesArray = (Array.isArray(values) ? values : [values]).map(val =>
      typeof val === 'string' ? val.replace(/–/g, '-') : val
    );

    // REMOVE LATER PLSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS
    if (valuesArray.includes("Yes") || valuesArray.includes("No")) return data;

    // Use Lodash's filter method to match values in the specified field
    const filteredData = _.filter(data, (item) => {
      let fieldValue = item[field];

      // Replace en-dash (–) with hyphen (-) if it's a string, to match standard filter keys
      if (typeof fieldValue === 'string') {
        fieldValue = fieldValue.replace(/–/g, '-');
      }

      // Check if valuesArray contains objects with min and max properties
      if (
        valuesArray.every(
          (val) => typeof val === "object" && "min" in val && "max" in val
        )
      ) {
        // console.log("I was the one called with min and max properties");
        return valuesArray.some(
          (val) =>
            (parseFloat(fieldValue) >= val.min && fieldValue <= val.max) ||
            fieldValue === null ||
            fieldValue === "ND" ||
            fieldValue === "NA" ||
            !(field in item)
        );
      }

      // Cast field value to integer if values are integers
      if (valuesArray.every((val) => Number.isInteger(val))) {
        return (
          valuesArray.includes(parseInt(fieldValue, 10)) ||
          fieldValue === null ||
          !(field in item) ||
          fieldValue === "ND" ||
          fieldValue === "NA"
        );
      }

      return (
        valuesArray.includes(fieldValue) ||
        fieldValue === null ||
        !(field in item) ||
        fieldValue === "ND" ||
        fieldValue === "NA"
      );
    });

    return filteredData;
  } catch (error) {
    console.error("Error filtering data:", error);
    return [];
  }
};

export const filterDataByMultipleFields = (
  data,
  properties,
  value,
  propertyFields,
  valueFields
) => {
  const initialFilteringData = getDataByMultipleFields(
    data,
    propertyFields,
    properties
  );
  const finalFilteringData = getDataByMultipleFields(
    initialFilteringData,
    valueFields,
    value
  );
  return finalFilteringData;
};

export const getDataByMultipleFields = (data, fields, values) => {
  try {
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error(
        "Invalid dataset provided. It should be an array of objects."
      );
    }

    if (!Array.isArray(fields)) {
      throw new Error("Fields and values should be arrays.");
    }

    // Use Lodash's filter method to match values in the specified fields
    const filteredData = _.filter(data, (item) => {
      return fields.some((field) => {
        const fieldValue = item[field];

        // Ensure values is an array for consistency
        const valuesArray = Array.isArray(values) ? values : [values];

        return valuesArray.some((value) => {
          // console.log({ value });
          // Check if value is an object with min and max properties
          if (typeof value === "object") {
            return (
              (parseFloat(fieldValue) >= value.min &&
                parseFloat(fieldValue) <= value.max) ||
              fieldValue === null ||
              fieldValue === "ND" ||
              fieldValue === "NA" ||
              !(field in item)
            );
          }

          // Cast field value to integer if value is an integer
          if (Number.isInteger(value)) {
            return (
              parseInt(fieldValue, 10) === value ||
              fieldValue === null ||
              !(field in item) ||
              fieldValue === "ND" ||
              fieldValue === "NA"
            );
          }

          return (
            fieldValue?.toLowerCase() === value.toLowerCase() ||
            fieldValue === null ||
            !(field in item) ||
            fieldValue === "ND" ||
            fieldValue === "NA"
          );
        });
      });
    });

    return filteredData;
  } catch (error) {
    console.error("Error filtering data:", error);
    return [];
  }
};

export const filterDataByOccurrence = (data, valueFields, values) => {
  const valuesKey = [...values].sort((a, b) => a - b).join('-');

  const filteredData = _.filter(data, (item) => {
    const isFoamingAgent = [
      "Agent moussant",
      "Agent moussant/Stabilisateur de mousse",
      "Stabilisateur de mousse",
    ].includes(item?.technofunctionality);

    // Calculate valueCount and total valid parameters in one pass for efficiency
    const valueCount = {};
    let countAboveOrEqual1 = 0; // Total count of all valid parameters (1 through 5)

    valueFields.forEach((field) => {
      const val = parseFloat(item[field]);
      if (!isNaN(val) && val >= 1 && val <= 5) {
        // Round to nearest integer if data isn't guaranteed clean, or use floor/ceil as appropriate
        const intVal = Math.round(val); 
        valueCount[intVal] = (valueCount[intVal] || 0) + 1;
        countAboveOrEqual1++;
      }
    });

    // --- Define Efficacity Tier Qualifications (Mutually Exclusive) ---
    
    const count5 = valueCount[5] || 0;
    const count4 = valueCount[4] || 0;
    const count3 = valueCount[3] || 0;

    // 1. STRONG (4 and/or 5 levels, min 2)
    // Only combinations of 4s and 5s that meet the min 2 count qualify.
    const isStrong = (count5 >= 2) || (count4 >= 2) || (count4 >= 1 && count5 >= 1);

    // 2. MEDIUM (Any values >= 3, min 2)
    // Total count of values 3, 4, and 5. Must NOT be Strong.
    const countAboveOrEqual3 = count3 + count4 + count5;
    const isMedium = !isStrong && (countAboveOrEqual3 >= 2);

    // 3. WEAK (Any valid parameter >= 1, min 2)
    // Total count of ALL valid parameters (1 through 5). Must NOT be Strong or Medium.
    // countAboveOrEqual1 calculated above.
    const isWeak = !isStrong && !isMedium && (countAboveOrEqual1 >= 2);
    
    
    // --- Apply Filtering Logic ---
    if (isFoamingAgent) {
      // Foaming Agent: Requires at least 1 occurrence of ANY specified value
      return values.some((value) => valueCount[value] >= 1);
    } else {
      // Non-Foaming Agent: Use mutually exclusive Efficacity tiers
      if (valuesKey === '4-5') {
        return isStrong;
      } else if (valuesKey === '3-4') {
        return isMedium;
      } else if (valuesKey === '1-2') {
        return isWeak;
      }
      return false; 
    }
  });

  return filteredData;
};

export const getIngredientsByTechnofunctionality = async (
  technofunctionality,
  offset = 5000
) => {
  if (!technofunctionality) return [];

  const _technofucntionality = technofunctionalities[technofunctionality];
  const url = `${API_URL}/ingredients/techno-ingredients?&technofunctionality=${_technofucntionality}`;
  const token = sessionStorage.getItem("authToken");

  try {
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();

    if (response.status === 401) {
      throw new Error("Login required");
    }

    if (data.status === "success") {
      const ingredients = data.ingredients;
      return ingredients;
    } else {
      console.log("Could not fetch data from server");
      return [];
    }
  } catch (error) {
    console.log(error);
    console.log("Error fetching ingredients");
  }
};
